import styled from 'styled-components';

export const Title = styled.h3`
    margin: 0;
    margin-bottom: 18px;
`;

export const Label = styled.div`
    margin-left: 6px;
`;

export const InputTextWrapper = styled.div`
    margin: 4px;
    display: flex;
    align-items: center;
    width: 140px;
    > div {
        margin-bottom: 0;
    }
    > div:first-of-type {
      margin-right: 6px;
    }
    > div label {
      display: none;
    }
    input {
      text-align: center;
    }
`;

export const UpperRow = styled.div`
    display: flex;
    justify-content: space-between;
    button {
        margin-bottom: 0;
        height: 36px;
        padding-top: 0;
        padding-bottom: 0;
    }
`;